module.exports = "pegasus_template/assets/blocks/column-17-theme4.png";